import React from 'react'
import { useCallback, useState, useRef, useEffect, useMemo, RefObject } from 'react'
import { useNavigate, useParams, useSearchParams } from "react-router-dom"
import { NavBar } from '../../../components/layout/NavBar';
import './Object.module.css'
import { Services } from '@/services/services';
import { Object } from '@/services/model/object';


export const ObjectPage = ({services}: {services: Services}) => {
  const [row, setRow] = useState<Object | null>()
  let oid = useParams().oid

  useEffect(() => {
    if(oid==='' || oid===undefined) {
      return
    }
    let id = services.objects.watcher.get(oid)!.listen((o: Object | null) => {
      setRow(o)
    })
    return () => {
      if(id===undefined) {
        return
      }
      services.objects.watcher.get(oid)!.remove(id)
    };
  }, [oid]);

  return (
    <div id='object-page'>
      <NavBar services={services} />
      <section className='object-page'>
        <h2>Object {oid}</h2>
        <table>
          <tr>
            <th>Stacyjka (Io239):</th>
            <td>{row?.params?.io239 !== undefined ? (row?.params?.io239 == '0' ? 'off' : 'on') : '-'}</td>
          </tr>
          <tr>
            <th>Napięcie baterii (Io66):</th>
            <td>{row?.params?.io66 !== undefined ? (Number(row.params.io66)/1000).toFixed(2)+'V' : '-' }</td>
          </tr>
          <tr>
            <th>Motogodziny (Io900):</th>
            <td>{row?.params?.io900 !== undefined ? (Number(row.params.io900)/10).toFixed(2)+'mth' : '-' }</td>
          </tr>
        </table>
        <p>
        {JSON.stringify(row)}
        </p>
      </section>

    </div>
  );
};
